export default "__VITE_ASSET__BuWwUwkM__"